import React from 'react';
import { Link } from 'react-router-dom';
import { Award, TrendingUp, Activity, Goal } from 'lucide-react';

function StatsHighlightsSection({ stats }) {
  // If no stats are available, show a placeholder
  if (!stats) {
    return null;
  }

  return (
    <section className="py-12 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-white">Season Statistics</h2>
          <Link to="/stats" className="text-yellow-400 hover:text-yellow-300 font-medium">
            Full Statistics →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Team Record */}
          <div className="bg-black rounded-lg p-6 border border-gray-800">
            <div className="flex items-start">
              <div className="bg-yellow-500 p-3 rounded-lg mr-4">
                <Award className="h-6 w-6 text-gray-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-400 mb-1">Team Record</h3>
                <div className="text-2xl font-bold text-white">{stats.record}</div>
                <div className="text-sm text-gray-500 mt-1">
                  {stats.standingPosition} in division
                </div>
              </div>
            </div>
          </div>

          {/* Winning Streak */}
          <div className="bg-black rounded-lg p-6 border border-gray-800">
            <div className="flex items-start">
              <div className="bg-yellow-500 p-3 rounded-lg mr-4">
                <TrendingUp className="h-6 w-6 text-gray-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-400 mb-1">Current Streak</h3>
                <div className="text-2xl font-bold text-white">
                  {stats.winningStreak > 0
                    ? `${stats.winningStreak}W`
                    : stats.winningStreak < 0
                      ? `${Math.abs(stats.winningStreak)}L`
                      : '0'}
                </div>
                <div className="text-sm text-gray-500 mt-1">
                  {stats.winningStreak > 0
                    ? 'Consecutive wins'
                    : stats.winningStreak < 0
                      ? 'Consecutive losses'
                      : 'No streak'}
                </div>
              </div>
            </div>
          </div>

          {/* Goals For */}
          <div className="bg-black rounded-lg p-6 border border-gray-800">
            <div className="flex items-start">
              <div className="bg-yellow-500 p-3 rounded-lg mr-4">
                <Goal className="h-6 w-6 text-gray-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-400 mb-1">Goals For</h3>
                <div className="text-2xl font-bold text-white">{stats.goalsFor}</div>
                <div className="text-sm text-gray-500 mt-1">
                  {(stats.goalsFor / 25).toFixed(2)} per game
                </div>
              </div>
            </div>
          </div>

          {/* Goals Against */}
          <div className="bg-black rounded-lg p-6 border border-gray-800">
            <div className="flex items-start">
              <div className="bg-yellow-500 p-3 rounded-lg mr-4">
                <Activity className="h-6 w-6 text-gray-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-400 mb-1">Goals Against</h3>
                <div className="text-2xl font-bold text-white">{stats.goalsAgainst}</div>
                <div className="text-sm text-gray-500 mt-1">
                  {(stats.goalsAgainst / 25).toFixed(2)} per game
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-10 text-center">
          <Link
            to="/stats"
            className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-3 rounded-md font-medium inline-block"
          >
            View Complete Team Statistics
          </Link>
        </div>
      </div>
    </section>
  );
}

export default StatsHighlightsSection;
